/**
 * @generated SignedSource<<df0617e310134dae33089799a6404738>>
 * @relayHash e98a8657c5786b6c810165bc3328b77f
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/442.0.0-2023-12-15T19:15:12.814Z/drsmUserAddAddressMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserAddAddressInput = {
  address: AddressInput;
  clientMutationId?: string | null;
  isGdprApplicable?: boolean | null;
  marketingOptIn?: boolean | null;
  mockAddressBook?: boolean | null;
  setNameOnProfile?: boolean | null;
  shipmentQuoteId?: string | null;
  transactionId?: string | null;
  userId: string;
  validateBuyerShipping?: boolean | null;
};
export type AddressInput = {
  active?: boolean | null;
  addressBookMember?: boolean | null;
  city?: string | null;
  company?: string | null;
  contact?: string | null;
  country?: string | null;
  firstName?: string | null;
  label?: string | null;
  lastName?: string | null;
  line1?: string | null;
  line2?: string | null;
  phoneNumber?: string | null;
  state?: string | null;
  zipCode?: string | null;
};
export type drsmUserAddAddressMutation$variables = {
  input: UserAddAddressInput;
};
export type drsmUserAddAddressMutation$data = {
  readonly userAddAddress: {
    readonly address: {
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly serviceId: string | null;
    } | null;
  } | null;
};
export type drsmUserAddAddressMutation = {
  response: drsmUserAddAddressMutation$data;
  variables: drsmUserAddAddressMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "drsmUserAddAddressMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserAddAddressPayload",
        "kind": "LinkedField",
        "name": "userAddAddress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "drsmUserAddAddressMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserAddAddressPayload",
        "kind": "LinkedField",
        "name": "userAddAddress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/442.0.0-2023-12-15T19:15:12.814Z/drsmUserAddAddressMutation",
    "metadata": {},
    "name": "drsmUserAddAddressMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "246ed39a82c73155cabaa7cd79e9db13";

export default node;
